export const APP_BANNER_HIDDEN = 'appBannerHidden';
export const BROKEN_IMAGES_HIDDEN = 'workingTimeAlertMay2019';
